const list = [
  { id: 'google', name: 'Google' },
  { id: 'apple', name: 'Apple' },
  { id: 'facebook', name: 'Facebook' },
  { id: 'twitter', name: 'Twitter' },
  { id: 'email', name: 'Email' },
  { id: 'stumbleupon', name: 'StumbleUpon', hasAccount: true }
]

// Define convenience methods

function findById(providerId) {
  return list.find(provider => provider.id === providerId)
}

function getName(providerId) {
  const found = list.findById(providerId)
  return found ? found.name : providerId
}

// Attach convenience methods to `list` Array

Object.defineProperties(list, {
  findById: { value: findById },
  getName: { value: getName }
})

module.exports = list
